<template>
  <div class="timesheet-entry-total">
    <div class="flex items-center justify-center mt-[12px] cursor-pointer" :class="disable ? 'clock-disable' : ''" ref="buttonRef">
      <img src="@/assets/icon_clock.svg" height="32" width="32" />
      <span class="font-semibold text-[36px] mx-[14px]" :style="{ opacity: displayHours != 0 || displayMins != 0 ? 1 : 0.4 }">
        {{ displayStr }}
      </span>
      <el-icon size="16px"><ArrowDown /></el-icon>
    </div>
    <div class="font-medium flex items-center justify-center mb-[8px]">
      <span class="text-[#ed1c2d] text-center" v-if="errorMessage">{{ errorMessage }}</span>
    </div>
    <el-popover ref="popoverRef" @before-leave="handleBeforeLeave" :virtual-ref="buttonRef" trigger="click" :width="220"
      :disabled="disable" virtual-triggering>
      <div class="p-[8px]">
        <div class="grid grid-flow-row auto-rows-max">
          <div class="font-medium text-sm mb-[8px]">Enter Time</div>
          <div class="grid grid-flow-col auto-cols-max">
            <div class="mr-[8px]">
              <div class="flex flex-col">
                <div>
                  <input class="h-[64px] w-[64px] text-center time-picker-component-input" type="text"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');if(Number(this.value)>23) this.value=23;"
                    onclick="this.select()" style="font-size: 36px; border: 1px solid #246bfd; border-radius: 6px;"
                    :value="hoursTmp" @change="handleUpdate($event, true)" />
                </div>
                <div class="mt-[6px] text-sm font-semibold"><span>Hours</span></div>
              </div>
            </div>
            <p class="text-center" style="font-size: 36px">:</p>
            <div class="ml-[8px]">
              <div class="flex flex-col">
                <div>
                  <input class="h-[64px] w-[64px] text-center time-picker-component-input" type="text"
                    oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');if(Number(this.value)>59) this.value=59;"
                    onclick="this.select()" style="font-size: 36px; border: 1px solid #246bfd; border-radius: 6px;"
                    :value="minutesTmp" @change="handleUpdate($event, false)" />
                </div>
                <div class="mt-[6px] text-sm font-semibold"><span>Minute</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center py-[12px]">
        <el-button class="btn-cancel" @click="handleCancel">Cancel</el-button>
        <el-button type="primary" class="btn-apply" style="background-color: #246bfd" @click="handleSubmit">Apply</el-button>
      </div>
    </el-popover>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, computed } from 'vue';
import { ArrowDown } from '@element-plus/icons-vue';

const props = defineProps<{
  hours?: number;
  minutes?: number;
  disable?: boolean;
  errorMessage?: string;
}>();
const emit = defineEmits<{
  (e: 'submit', payload: { hours: number; minutes: number }): void;
}>();

const buttonRef = ref();
const popoverRef = ref();
const isValid = ref<boolean>(false);
const hoursTmp = ref<number>(props.hours ?? 0);
const minutesTmp = ref<number>(props.minutes ?? 0);

watch(() => [props.hours, props.minutes], () => {
  hoursTmp.value = props.hours ?? 0;
  minutesTmp.value = props.minutes ?? 0;
});

const handleUpdate = (event: any, isHours: boolean) => {
  if (isHours) {
    hoursTmp.value = parseInt(event.target.value) || 0;
  } else {
    let mins = parseInt(event.target.value) || 0;
    if (mins > 60) {
      hoursTmp.value += Math.floor(mins / 60);
      mins = mins % 60;
    }
    minutesTmp.value = mins;
  }
};

const handleSubmit = () => {
  isValid.value = false;
  emit('submit', { hours: hoursTmp.value, minutes: minutesTmp.value });
  popoverRef.value?.hide?.();
};
const handleCancel = () => popoverRef.value?.hide?.();
const handleBeforeLeave = () => {
  hoursTmp.value = props.hours ?? 0;
  minutesTmp.value = props.minutes ?? 0;
};

const displayHours = computed(() => props.hours ?? 0);
const displayMins = computed(() => props.minutes ?? 0);
const displayStr = computed(() => {
  const h = displayHours.value >= 10 ? displayHours.value : '0' + displayHours.value;
  const m = displayMins.value >= 10 ? displayMins.value : '0' + displayMins.value;
  return `${h}h:${m}m`;
});
</script>

<style lang="scss" scoped>
.btn-apply {
  border: none;
  padding: 10px 20px;
  &:hover,
  &:focus {
    color: white !important;
  }
}
.btn-cancel {
  padding: 10px 20px;
}
.clock-disable {
  cursor: text !important;
}
</style>


